import { css, GridCol, GridRow, mixins, styled } from '@bob/library'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'

export const Headline = styled.h2`
  ${mixins.typography.headlineMedium}
  width: 100%;
  ${mixins.media.min.tablet} {
    ${mixins.padding.bottom(10)}
  }
  ${mixins.margin(0)}
  border-bottom: 2px solid ${mixins.colors.grayBlack};
`

const margin = css`
  ${mixins.margin.bottom(60)}
  ${mixins.media.min.tablet} {
    ${mixins.margin.bottom(60)}
  }
`

export const RowWithMargin = styled(GridRow)`
  ${margin}
`

export const ColWithMargin = styled(GridCol)`
  ${margin}
`

export const StyledLink = styled(SpotLinkAnchor)`
  ${mixins.cta.hyperlink('black')}
  display: flex;
  border-bottom: 1px solid ${mixins.colors.grayMid};
  & {
    color: ${mixins.colors.grayDark};
    ${mixins.padding(10, 0)}
    text-transform: none;
  }
`
